// extracted by mini-css-extract-plugin
export default {"commentHeader":"ayEX5G","search":"nVnCm7","commentTime":"sTSu0g","withMoreButton":"sYGQY1","moreButton":"PzFWm5","isBestAnswer":"SrJH8K"};